import { Badge } from "@/components/ui/badge";
import type { SituationStatus } from "@/@types/unlock-request";
import { SITUATION_STATUS } from "@/constants/access-request";
import { UNLOCK_SITUATION_FALLBACK_LABEL } from "@/constants/messages";

interface SituationCellProps {
  situation: string | null;
  situationStatus: SituationStatus;
}

export const SituationCell = ({
  situation,
  situationStatus,
}: SituationCellProps): JSX.Element => {
  if (situationStatus === SITUATION_STATUS.FOUND) {
    return situation ? (
      <Badge variant="secondary">{situation}</Badge>
    ) : (
      <Badge variant="outline">-</Badge>
    );
  }
  return (
    <Badge variant="outline">
      {UNLOCK_SITUATION_FALLBACK_LABEL[situationStatus]}
    </Badge>
  );
};
